export const splitAgencyCode = ' - ';

export const typeCalendar: string[] = ['REGISTRAZIONE', 'COMPETENZA'];

export const formatMessage: string = 'Formato valido: xxx,xx o xxx.xx';
